<!-- TABS -->
<app-titulo-paginas titulo="Relatório Mensal"></app-titulo-paginas>
<div *ngIf="loading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<mat-card class="example-card" *ngIf="!loading && !loadingPatient && !loadingServices;else templateLoading">
  <mat-card-header>
    <mat-card-title> Cadastro de Relatório </mat-card-title>
  </mat-card-header>
  <form [formGroup]="formulario">
    <mat-card-content>
      <mat-tab-group>
        <mat-tab>
          <ng-template mat-tab-label *ngIf="
              usuario.user.pessoa.prestador.formacoes[0].descricao ==
              'Fonoaudiologia'
            ">
            <mat-icon class="example-tab-icon">assignment</mat-icon>
            Fonoaudióloga(o)
          </ng-template>
          <ng-template mat-tab-label *ngIf="
              usuario.user.pessoa.prestador.formacoes[0].descricao == 'Medicina'
            ">
            <mat-icon class="example-tab-icon">assignment</mat-icon>
            Médico(a)
          </ng-template>
          <ng-template mat-tab-label *ngIf="
              usuario.user.pessoa.prestador.formacoes[0].descricao ==
              'Fisioterapia'
            ">
            <mat-icon class="example-tab-icon">assignment</mat-icon>
            Fisioterapeuta
          </ng-template>
          <ng-template mat-tab-label *ngIf="
              usuario.user.pessoa.prestador.formacoes[0].descricao ==
                'Enfermagem' ||
              usuario.user.pessoa.prestador.formacoes[0].descricao ==
                'Técnico de Enfermagem'
            ">
            <mat-icon class="example-tab-icon">assignment</mat-icon>
            Enfermeiro
          </ng-template>

          <div class="linha-editor" style="margin-top: 30px">
            <div class="row" style="justify-content: center">
              <div class="alert alert-warning" role="alert">
                <i class="fas fa-exclamation-triangle"></i>
                <strong>
                  Para pesquisar os atendimentos é necessário preencher os
                  campos: paciente, mês e ano.
                </strong>
              </div>
            </div>

            <div class="row" style="justify-content: center">
              <div class="col-lg-6" style="margin-bottom: 12px">
                <app-input errorMessage="Campo obrigatório" label="Paciente" obrigatorio="true"
                  info="Selecione um Paciente">
                  <ng-select id="tipo" formControlName="paciente_id" style="margin-top: 10px"
                    notFoundText="Nenhum paciente encontrado" (change)="getPatient($event)" clearAllText="Limpar tudo"
                    [loading]="loadingPatient" [placeholder]="
                      loadingPatient
                        ? 'Carregando pacientes.'
                        : 'Selecione um paciente'
                    ">
                    <ng-option *ngFor="let pac of pacientesByPrestador" [value]="pac">
                      {{ pac.label | titlecase }} -
                      {{ pac.servico_name | titlecase }}
                    </ng-option>
                  </ng-select>
                </app-input>
              </div>
            </div>
            <div class="row" *ngIf="cardPatient" style="justify-content: center">
              <div class="col-lg-6">
                <mat-card class="example-card" style="background-color: #4aa28f0e; margin: 10px">
                  <mat-card-title class="text-center" style="color: #49a28f; margin-bottom: 30px">
                    {{ patient?.label | titlecase }}
                  </mat-card-title>
                  <mat-card-subtitle>
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="col-md-6">
                          <h6 class="text-center">
                            <i class="fas fa-notes-medical" style="color: #49a28f"></i>
                            Informações do paciente:
                          </h6>
                          <p class="text-center">
                            Nascimento: {{ patient?.nasc | date: 'dd/MM/yyyy' }}
                          </p>
                          <p class="text-center">
                            Convênio: {{ patient?.client | titlecase }}
                          </p>
                          <p class="text-center">
                            Serviço: {{ patient?.servico_name | titlecase }}
                          </p>
                        </div>
                        <div class="col-md-6">
                          <h6 class="text-center">
                            <i class="fas fa-stethoscope" style="color: #49a28f"></i>
                            PAD de atendimentos:
                          </h6>
                          <div *ngIf="services != null; else templateService">
                            <p *ngFor="let item of services" class="text-center">
                              {{ item }}
                            </p>
                          </div>
                          <ng-template #templateService>
                            <p style="font-weight: bold">Sem atendimentos!</p>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </mat-card-subtitle>
                </mat-card>
              </div>
            </div>
            <div class="row" style="justify-content: center">
              <div class="col-lg-3">
                <app-input errorMessage="Campo obrigatório" label="Mês referência" obrigatorio="true"
                  info="Informe um mês de referência">
                  <select class="form-control" formControlName="mes" name="mes" id="mes">
                    <option value="" disabled selected>Selecione o mês</option>
                    <option value="1">JANEIRO</option>
                    <option value="2">FEVEREIRO</option>
                    <option value="3">MARÇO</option>
                    <option value="4">ABRIL</option>
                    <option value="5">MAIO</option>
                    <option value="6">JUNHO</option>
                    <option value="7">JULHO</option>
                    <option value="8">AGOSTO</option>
                    <option value="9">SETEMBRO</option>
                    <option value="10">OUTUBRO</option>
                    <option value="11">NOVEMBRO</option>
                    <option value="12">DEZEMBRO</option>
                  </select>
                </app-input>
              </div>
              <div class="col-lg-3">
                <app-input errorMessage="Campo obrigatório" label="Ano referência" obrigatorio="true"
                  info="Informe um ano de referência">
                  <input type="text" name="ano" class="form-control" formControlName="ano" maxlength="4" minlength="4"
                    placeholder="Ano de referência" />
                </app-input>
              </div>
            </div>
            <div class="row" style="justify-content: center" *ngIf="isNotProfessionalForHH">
              <div class="col-lg-1" style="margin: 10px auto">
                <button class="btn btn-primary" style="margin: auto" (click)="filterScales()">
                  Pesquisar
                </button>
              </div>
            </div>

            <ng-template *ngIf="isNotProfessionalForHH">
              <app-form-service-date [list_items]="days"></app-form-service-date>

              <div *ngIf="loadingServiceDate">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>

              <app-form-service-forecast (service_forecast)="getServiceForecast($event)"
              [data]="days_forecast"></app-form-service-forecast>
            </ng-template>

            <div class="row" style="margin-top: 15px">
              <div [ngClass]="isNotProfessionalForHH ? 'col-lg-6' : 'col-lg-12'">
                <app-input errorMessage="Campo obrigatório" label="Diagnóstico de Inclusão"
                  info="Informe o Diagnóstico de Inclusão">
                  <div class="input-group">
                    <textarea type="text" class="form-control" placeholder="Diagnóstico de Inclusão..."
                      formControlName="inclusion_diagnosis" name="inclusion_diagnosis"></textarea>
                  </div>
                </app-input>
              </div>
              <div [ngClass]="isNotProfessionalForHH ? 'col-lg-6' : 'col-lg-12'">
                <app-input errorMessage="Campo obrigatório" label="Histórico Clínico"
                  info="Informe o Histórico Clínico">
                  <div class="input-group">
                    <textarea type="text" class="form-control" placeholder="Histórico clínico..."
                      formControlName="historico_clinico" name="historico_clinico"></textarea>
                  </div>
                </app-input>
              </div>
            </div>
            <div class="row" style="margin-top: 15px">
              <div class="col-lg-6" *ngIf="isNotProfessionalForHH">
                <app-input errorMessage="Campo obrigatório" label="Descrição da Lesão (altura, largura, tecido característica geral/ conduta)"
                  info="Informe o Resumo da Internação">
                  <div class="input-group">
                    <textarea type="text" class="form-control" placeholder="Resumo da Internação..."
                      formControlName="hospitalization_summary" name="hospitalization_summary"></textarea>
                  </div>
                </app-input>
              </div>
              <div [ngClass]="isNotProfessionalForHH ? 'col-lg-6' : 'col-lg-12'">
                <app-input errorMessage="Campo obrigatório" label="Evolução Mensal" info="Informe a Evolução Mensal" obrigatorio="true">
                  <div class="input-group">
                    <textarea type="text" class="form-control" placeholder="Evolução Mensal..."
                      formControlName="month_evolution" name="month_evolution"></textarea>
                  </div>
                </app-input>
              </div>
            </div>
            <div class="row" style="margin-top: 15px" *ngIf="isNotProfessionalForHH">
              <div class="col-lg-12">
                <h5 class="text-center">Sinais Vitais</h5>
                <div class="row">
                  <div class="col-lg-3">
                    <app-input errorMessage="Campo obrigatório" label="PA-Pressão Arterial"
                      info="Informe o PA-Pressão Arterial">
                      <div class="input-group">
                        <input class="form-control" formControlName="pa" type="text" placeholder="000-00" />
                      </div>
                    </app-input>
                  </div>
                  <div class="col-lg-3">
                    <app-input errorMessage="Campo obrigatório" label="P-Pulso" info="Informe o P-Pulso">
                      <div class="input-group">
                        <input class="form-control" formControlName="p" type="text" placeholder="00" />
                      </div>
                    </app-input>
                  </div>
                  <div class="col-lg-3">
                    <app-input errorMessage="Campo obrigatório" label="T-Temperatura" info="Informe o T-Temperatura">
                      <div class="input-group">
                        <input class="form-control" formControlName="t" type="text" placeholder="00.0 °C" />
                      </div>
                    </app-input>
                  </div>
                  <div class="col-lg-3">
                    <app-input errorMessage="Campo obrigatório" label="Fr-Frequência" info="Informe o Fr-Frequência">
                      <div class="input-group">
                        <input class="form-control" formControlName="fr" type="text" placeholder="00" />
                      </div>
                    </app-input>
                  </div>
                  <div class="col-lg-3">
                    <app-input errorMessage="Campo obrigatório" label="Sat%-Saturação" info="Informe o Sat%-Saturação">
                      <div class="input-group">
                        <input class="form-control" formControlName="sat" type="text" placeholder="00%" />
                      </div>
                    </app-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" style="margin-top: 15px" *ngIf="isNotProfessionalForHH">
              <div class="col-lg-6">
                <app-input errorMessage="Campo obrigatório" label="Equipamentos" info="Informe os Equipamentos">
                  <div class="input-group">
                    <textarea type="text" class="form-control" placeholder="Equipamentos..."
                      formControlName="equipments" name="equipments"></textarea>
                  </div>
                </app-input>
              </div>
              <div class="col-lg-6">
                <app-input errorMessage="Campo obrigatório" label="Dispositivos" info="Informe os Dispositivos">
                  <div class="input-group">
                    <textarea type="text" class="form-control" placeholder="Dispositivos..."
                      formControlName="dispositivo" name="dispositivo"></textarea>
                  </div>
                </app-input>
              </div>
            </div>
            <div class="row" style="margin-top: 15px" *ngIf="isNotProfessionalForHH">
              <div class="col-lg-6">
                <app-input errorMessage="Campo obrigatório" label="Quadro Motor" info="Informe o Quadro Motor">
                  <div class="input-group">
                    <textarea type="text" class="form-control" placeholder="Quadro Motor..."
                      formControlName="quadro_motor" name="quadro_motor"></textarea>
                  </div>
                </app-input>
              </div>
              <div class="col-lg-6">
                <app-input errorMessage="Campo obrigatório" label="Quadro Respiratório"
                  info="Informe o Quadro Respiratório">
                  <div class="input-group">
                    <textarea type="text" class="form-control" placeholder="Quadro Respiratório..."
                      formControlName="quadro_respiratorio" name="quadro_respiratorio"></textarea>
                  </div>
                </app-input>
              </div>
            </div>
            <div class="row" style="margin-top: 15px" *ngIf="isNotProfessionalForHH">
              <div class="col-lg-6">
                <app-input errorMessage="Campo obrigatório"
                  label="Sistemas (gastrintestinais, geniturinário, pele e tegumento)" info="Informe os Sistemas">
                  <div class="input-group">
                    <textarea type="text" class="form-control" placeholder="Sistemas..." formControlName="systems"
                      name="systems"></textarea>
                  </div>
                </app-input>
              </div>
              <div class="col-lg-6">
                <app-input errorMessage="Campo obrigatório" label="Orientações e Conduta"
                  info="Informe as Orientações e Conduta" obrigatorio="true">
                  <div class="input-group">
                    <textarea type="text" class="form-control" placeholder="Orientações e Conduta..."
                      formControlName="guidelines_conduct" name="guidelines_conduct"></textarea>
                  </div>
                </app-input>
              </div>
            </div>
            <div class="row" style="margin-top: 15px" *ngIf="isNotProfessionalForHH">
              <div class="col-lg-6">
                <app-input errorMessage="Campo obrigatório" label="Metas Terapêuticas (prognóstico)"
                  info="Informe as Metas Terapêuticas" obrigatorio="true">
                  <div class="input-group">
                    <textarea type="text" class="form-control" placeholder="Metas Terapêuticas..."
                      formControlName="metas_terapeuticas" name="metas_terapeuticas"></textarea>
                  </div>
                </app-input>
              </div>
              <div class="col-lg-6">
                <app-input errorMessage="Campo obrigatório" label="Justificativa" info="Informe as Justificativa" obrigatorio="true">
                  <div class="input-group">
                    <textarea type="text" class="form-control" placeholder="Justificativa..."
                      formControlName="justifications" name="justifications"></textarea>
                  </div>
                </app-input>
              </div>
            </div>
            <div class="row" style="margin-top: 15px" *ngIf="isNotProfessionalForHH">

              <!-- FONO -->
              <div class="col-lg-6" *ngIf="
                  usuario.user.pessoa.prestador.formacoes[0].descricao ==
                  'Fonoaudiologia'
                ">
                <app-input errorMessage="Campo obrigatório" label="Plano Terapêutico Atual"
                  info="Informe o Plano Terapêutico Atual">
                  <div class="input-group">
                    <textarea type="text" class="form-control" id="plano_terapeutico"
                      placeholder="Plano Terapêutico Atual..." formControlName="plano_terapeutico"
                      name="plano_terapeutico">
                    </textarea>
                  </div>
                </app-input>
              </div>
              <div class="col-lg-6" *ngIf="
                  usuario.user.pessoa.prestador.formacoes[0].descricao ==
                  'Fonoaudiologia'
                ">
                <app-input errorMessage="Campo obrigatório" label="Objetivo" info="Informe o Objetivo">
                  <div class="input-group">
                    <textarea type="text" class="form-control" id="objetivo" placeholder="Objetivo..."
                      formControlName="objetivo" name="objetivo">
                    </textarea>
                  </div>
                </app-input>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
    <mat-card-actions align="end">
      <button type="button" class="btn btn-secondary" (click)="cancelReports()"
        style="border-radius: 18px; margin-left: 9px">
        Cancelar
      </button>
      <button class="btn btn-warning" type="button" (click)="openModalSignature()" style="border-radius: 19px; margin-right: 6px; margin-left: 6px;">
        <i class="fas fa-signature"></i>
        Assinar
      </button>
      <button type="submit" class="btn btn-success" style="border-radius: 18px" *ngIf="!salvando" (click)="sendForm()"
        [disabled]="
          !formulario.value.paciente_id ||
          !formulario.value.mes ||
          !formulario.value.ano ||
          !formulario.value.assinatura
        ">
        {{ !formulario.value.id ? 'Salvar Relatório' : 'Alterar Relatório' }}
      </button>
      <button class="btn btn-success btn-madelife" *ngIf="salvando" disabled style="border-radius: 18px">
        <i class="fa fa-spin fa-spinner"></i>
        Salvando
      </button>
    </mat-card-actions>
  </form>
</mat-card>

<ng-template #templateLoading>
  <div class="text-center">
    <i class="fas fa-spin fa-spinner fa-5x"></i>
    <p>
      Carregando informações...
    </p>
  </div>
</ng-template>
